import { render, staticRenderFns } from "./MetricCards.vue?vue&type=template&id=d0397704&scoped=true"
import script from "./MetricCards.vue?vue&type=script&lang=js"
export * from "./MetricCards.vue?vue&type=script&lang=js"
import style0 from "./MetricCards.vue?vue&type=style&index=0&id=d0397704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0397704",
  null
  
)

export default component.exports